import request from "@/request/request.js";

// 公共
const common = {
  login(data) {
    return request({
      url: "/auth/login",
      method: "post",
      data,
    });
  },
  getAdminUserInfoByToken(data) {
    return request({
      url: "/auth/userInfoByToken",
      method: "get",
      params:data,
    });
  },
  getList(data) {
    return request({
      url: "/auth/list",
      method: "get",
      params:data,
      
    });
  }
};
const user = {
  
  getList(data) {
    return request({
      url: "/auth/listadmin",
      method: "get",
      params:data,
    });
  },
  create(data) {
    return request({
      url: "/auth/create",
      method: "post",
      data,
    });
  },
  update(data) {
    return request({
      url: "/auth/upDate",
      method: "post",
      data,
    });
  },
  del(data) {
    return request({
      url: "/auth/delete",
      method: "post",
      data,
    });
  },
  export() {
    return request({
      url: "/auth/exportExcel",
      method: "get"
    });
  },
};
const appointment = {
  getList(data) {
    return request({
      url: "/appointment/adminlist",
      method: "get",
      params:data,
    });
  },
  update(data) {
    return request({
      url: "/appointment/changeStatus",
      method: "post",
      data,
    });
  },
  del(data) {
    return request({
      url: "/appointment/delete",
      method: "post",
      data,
    });
  },
};
const activity = {
  getList(data) {
    return request({
      url: "/activity/list",
      method: "get",
      params:data,
    });
  },
  create(data) {
    return request({
      url: "/activity/update",
      method: "post",
      data,
    });
  },
  update(data) {
    return request({
      url: "/activity/addApplintment",
      method: "post",
      data,
    });
  },
  del(data) {
    return request({
      url: "/activity/delete",
      method: "post",
      data,
    });
  },
};
export default {
  common,
  user,
  appointment,
  activity
};
